export default __webpack_public_path__ + "static/media/gallery_16.2221225a.jpg";